// Main Scripts
(function ($) {
  $(window).on("load", function () {
    //console.log(ajax_object);
    // Responsive embeds
    $(".content iframe").addClass("embed-responsive-item");
    $(".content iframe").wrap(
      "<div class='embed-responsive embed-responsive-16by9'/>"
    );

    $(".side-section .show_filters").on("click", function () {
      if ($(this).hasClass("is-active")) {
        $(this).removeClass("is-active").text("SHOW Filters");
        $(".wcpf-filter-inner").slideUp();
      } else {
        $(this).addClass("is-active").text("Hide Filters");
        $(".wcpf-filter-inner").slideDown();
      }
    });

    $(".open_search_wrapper").on("click", function () {
      if ($(this).hasClass("is-active")) {
        $(this).removeClass("is-active");
        $(".head_search_wrapper").fadeOut();
      } else {
        $(this).addClass("is-active");
        $(".head_search_wrapper").fadeIn();
      }
    });

    // Hamburger menu
    $(".hamburger").on("click", function () {
      if ($(this).hasClass("is-active")) {
        $(this).removeClass("is-active");
        $(".mobile-menu, body, .hamburger").removeClass("is-active");
      } else {
        $(this).addClass("is-active");
        $(".mobile-menu, body, .hamburger").addClass("is-active");
      }
    });

    $("#filters input").on("change", function () {
      var paged = 0;
      var originalText = $("#load-more-posts").text(); // Save the original text
      $("#load-more-posts span").text("Loading...");

      // Get selected taxonomy terms
      var selectedTerms = [];
      $("input[name='terms[]']:checked").each(function () {
        selectedTerms.push($(this).val()); // Collect checked values
      });

      var data = {
        action: "load_filtered_results",
        paged: paged,
        terms: selectedTerms, // Send selected taxonomy terms
      };

      $.ajax({
        url: ajax_object.ajaxurl,
        data: data,
        type: "POST",
        success: function (data) {
          if (data) {
            data = JSON.parse(data);
            //  console.log(data);
            $("#results .inner").html(data.output); // Replace results instead of appending

            if (data.max_pages == data.paged || data.post_count == 0) {
              $("#load-more-posts").hide();
            } else {
              $("#load-more-posts").show();
            }

            $("#load-more-posts").attr("attr-number", data.paged);
          }
        },
        complete: function () {
          $("#load-more-posts span").text(originalText);
        },
      });
    });

    if ($(window).width() < 1024) {
      $("#menu_drop").on("click", function () {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $("#cat_options").slideUp();
        } else {
          $(this).addClass("active");
          $("#cat_options").slideDown();
        }
      });
    }

    $("#mobile-menu li.menu-item-has-children .arrow").on("click", function () {
      // Close all other active submenus and remove their active class
      $("#mobile-menu li.menu-item-has-children .arrow")
        .not(this)
        .removeClass("active")
        .next("ul.sub-menu")
        .slideUp();

      // Toggle the clicked submenu
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).next("ul.sub-menu").slideUp();
      } else {
        $(this).addClass("active");
        $(this).next("ul.sub-menu").slideDown();
      }
    });

    // Open popup
    $(".searchbox").on("click", function () {
      $("#form_popup").addClass("active");
    });

    // Close popup when clicking outside .inner
    $(document).on("click", function (event) {
      if (
        !$(event.target).closest("#form_popup .inner").length &&
        !$(event.target).closest(".searchbox").length
      ) {
        $("#form_popup").removeClass("active");
      }
    });

    // Close popup when clicking .close button
    $("#form_popup .close").on("click", function () {
      $("#form_popup").removeClass("active");
    });

    $("#load-more-posts").on("click", function () {
      var paged = $("#load-more-posts").attr("attr-number");
      var originalText = $("#load-more-posts").text(); // Save the original text
      $("#load-more-posts span").text("Loading...");

      // Get selected taxonomy terms
      var selectedTerms = [];
      $("input[name='terms[]']:checked").each(function () {
        selectedTerms.push($(this).val()); // Collect checked values
      });

      var data = {
        action: "load_filtered_results",
        paged: paged,
        terms: selectedTerms, // Send selected taxonomy terms
      };

      //  console.log(data);

      $.ajax({
        url: ajax_object.ajaxurl,
        data: data,
        type: "POST",
        success: function (data) {
          if (data) {
            data = JSON.parse(data);
            // console.log(data);
            $("#results .inner article:last-child").after(data.output); // Replace results instead of appending

            if (data.max_pages == data.paged || data.post_count == 0) {
              $("#load-more-posts").hide();
            } else {
              $("#load-more-posts").show();
            }

            $("#load-more-posts").attr("attr-number", data.paged);
          }
        },
        complete: function () {
          $("#load-more-posts span").text(originalText);
        },
      });
    });
  });
})(jQuery);
